import React, { useState } from "react"
import { message } from "antd"
import { mixPostV1 } from "services/mixin"

const LoginPage = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newErrors = {}
    if (!email) newErrors.email = "Trường này là bắt buộc"
    if (!password) newErrors.password = "Trường này là bắt buộc"
    setErrors(newErrors)

    if (Object.keys(newErrors).length > 0) return

    try {
      setLoading(true)
      const res = await mixPostV1("/api/v1/be/login", {
        email,
        password,
      })
      console.log("Response đầy đủ:", res)
      if (res?.status === true) {
        message.success("Đăng nhập thành công!")
        const token = res?.data?.access_token
        if (token) {
          localStorage.setItem("token", token)
        }
        if (res?.data) {
          localStorage.setItem("user", JSON.stringify(res.data))
        }
        setTimeout(() => {
          window.location.href = "/"
        }, 500)
      } else {
        // Lấy message lỗi
        const errorMsg = res?.msg || "Email hoặc mật khẩu không đúng!"
        message.error(errorMsg)
        console.error("Login failed:", res)
      }
    } catch (err) {
      console.error("Login error:", err)
      
      const errorMsg = 
        err?.response?.data?.message || 
        err?.message || 
        "Có lỗi xảy ra, vui lòng thử lại!"
      
      message.error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md relative">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">AiHub</h2>
          <p className="text-gray-500 mt-1">
            Vui lòng đăng nhập vào tài khoản của bạn và bắt đầu
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              placeholder="exp@email.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                if (errors.email) setErrors({ ...errors, email: "" })
              }}
              className={`w-full px-3 py-2 border ${
                errors.email ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mật khẩu
            </label>
            <input
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                if (errors.password) setErrors({ ...errors, password: "" })
              }}
              className={`w-full px-3 py-2 border ${
                errors.password ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500`}
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>
          <div className="flex justify-end">
            <a href="#" className="text-sm text-teal-600 hover:underline">
              Quên mật khẩu?
            </a>
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full !bg-teal-600 hover:!bg-teal-700 text-white py-2 rounded-lg font-semibold transition ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Đang đăng nhập..." : "Đăng Nhập"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default LoginPage